import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    shortSummary_container: {},
    box_wrapper: {
        width: "100%",
    },
    container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        flexDirection: "column",
        width: "100%",
        padding: 18,
    },
    header_container: {
        fontSize: "16px",
        fontWeight: "bold",
    },
    content: {
        marginTop: 12,
    },
    values_container: {
        marginTop: 2,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        width: "100%",
    },
    item_title: {
        width: 205,
        fontSize: "14px",
        letterSpacing: 0,
        lineHeight: "26px",
    },
    values: {
        fontSize: "13px",
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "26px",
        width: "100%",
    },
    cropData: {
        display: "flex",
        flexDirection: "row",
    },
    cropImage: {
        marginLeft: 10,
        height: 40,
        width: 40,
        // marginBottom: 50,
        // top: 130,
        // right: 0,
        // left: 210,
        // position: 'absolute',
        //backgroundColor: 'red',
        borderRadius: 20,
    },
}));

export default useStyles;
